import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/customericon.jpg';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import disableIcon from '../images/disableicon.png';
import { data } from "react-router";
import { exportArrayToExcel } from "../common/mylib";
import excel from '../images/excelicon.png';
const Customers=()=>
{
const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [subscriberdata,setSubscriberData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({id:"",name:"",company:"",address:"",state:"",city:"",pincode:"",mobile:"",whatsapp:"",email:"",panno:"",aadhar:"",gstin:"",photo:"",panphoto:"",aadharphoto:"",isdeleted:"N",isfranchisee:"N"});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(10);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);
    const [plans,setPlans]=useState([]);
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Company", key: "company", sortable: true},
        { name: "Address", key: "address", sortable: false },        
        { name: "Mobile", key: "mobile", sortable: false },
        { name: "Email", key: "email", sortable: false },
        { name: "Name", key: "sname", sortable: true},      
        { name: "Facility", key: "currentfacility", sortable: true},
        { name: "Current Plan", key: "currentplan", sortable: true},
        { name: "Expiry Date", key: "planexpiry", sortable: true},
        { name: "Plan Amount", key: "planamount", sortable: true },                
    ];
    function addSubsriber(event)
    {
        setFormData({id:"",name:"",company:"",address:"",state:"",city:"",pincode:"",mobile:"",whatsapp:"",email:"",panno:"",aadhar:"",gstin:"",photo:"",panphoto:"",aadharphoto:"",isdeleted:"N",isfranchisee:"N"});
        setShow(true);
    }
    async function saveData(event)
    {
        setMsg("");
        if(formData.company.trim()=="")
        {
            setMsg("Company Name is required");
            return;
        }
        if(formData.name.trim()=="")
        {
            setMsg("Name is required");
            return;
        }
        if(formData.address.trim()=="")
        {
            setMsg("Address is required");
            return;
        }
        if(formData.mobile.trim().length!=10)
        {
            setMsg("Mobile must be 10 digits");
            return;
        }
        if(formData.whatsapp.trim().length!=10)
        {
            setMsg("WhatsApp must be 10 digits");
            return;
        }
        if(formData.email.trim()!="" && !formData.email.includes("@"))
        {
            setMsg("Email is not valid");
            return;
        }
        if(window.confirm('Are you sure?'))        {
            
            setProgress(true);
            let url="/api/Subscription/SaveSubscriber";            
            if(formData.id!="") url="/api/Subscription/UpdateSubscriber/"+formData.id;
            //console.log("Token:"+localStorage.getItem("token"));            
            let datajson=JSON.stringify(formData);  
            //console.log(datajson);         
                await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadSubscribers();
                        alert("Data Saved Successfully");
                        setFormData({id:"",name:"",company:"",address:"",state:"",city:"",pincode:"",mobile:"",whatsapp:"",email:"",panno:"",aadhar:"",gstin:"",photo:"",panphoto:"",aadharphoto:"",isdeleted:"N",isfranchisee:"N"});
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });   
        }
        setProgress(false);
    }
    async function loadSubscribers()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetAllSubscribers").then(res=>
        {
            if(res.status==200)
            {
                setSubscriberData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                let f1=res.data.data.map(e=>e.currentfacility);
                let p1=res.data.data.map(e=>e.currentplan);
                let f2=new Set(f1);
                let p2=new Set(p1);
                let p3=[...p2].sort();
                let f3=[...f2].sort();
                if (f3.length === 0) 
                    f3 = ["Facility"];
                else if ((f3[0] || "").trim() === "") 
                    f3[0] = "Facility";
                else f3.splice(0,0,"Facility");

                if(p3[0].trim()=="")
                    p3[0]="Plan";
                else
                    p3.splice(0,0,"Plan");
                setFacilities([...f3]);
                setPlans([...p3]); 
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });     
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=subscriberdata.filter((e)=>e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.sname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(subscriberdata);                
                setPageData(subscriberdata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=subscriberdata.filter((e)=>e.currentfacility==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...subscriberdata]);
                setPageData(subscriberdata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchPlan")
        {
            if(event.target.value!="Plan")
            {
                let searchResult=subscriberdata.filter((e)=>e.currentplan==event.target.value);   
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...subscriberdata]);
                setPageData(subscriberdata.slice(0,pageSize));
            }
            setPage(1);
        }            
    }
    function formValueChanged(event)
    {
        if(event.target.id=="id") setFormData({...formData,id:event.target.value});
        if(event.target.id=="company") setFormData({...formData,company:event.target.value});
        if(event.target.id=="name") setFormData({...formData,name:event.target.value});
        if(event.target.id=="mobile") setFormData({...formData,mobile:event.target.value});
        if(event.target.id=="whatsapp") setFormData({...formData,whatsapp:event.target.value});
        if(event.target.id=="email") setFormData({...formData,email:event.target.value});
        if(event.target.id=="panno") setFormData({...formData,panno:event.target.value});
        if(event.target.id=="aadhar") setFormData({...formData,aadhar:event.target.value});
        if(event.target.id=="gstin") setFormData({...formData,gstin:event.target.value});
        if(event.target.id=="address") setFormData({...formData,address:event.target.value});
        if(event.target.id=="state") setFormData({...formData,state:event.target.value});
        if(event.target.id=="city") setFormData({...formData,city:event.target.value});
        if(event.target.id=="pincode") setFormData({...formData,pincode:event.target.value});       
        if(event.target.id=="aadharphoto") 
        {
            const { name, files: selectedFiles } = event.target;
            const file = selectedFiles[0];
            if (!file) return;
            // Preview URL
            const previewUrl = URL.createObjectURL(file);
            // Convert to Base64
            const reader = new FileReader();
            reader.onloadend = () => 
            {
                setFormData({...formData,aadharphoto:reader.result});                
            };
            reader.readAsDataURL(file);            
        }
        if(event.target.id=="panphoto") 
        {
            const { name, files: selectedFiles } = event.target;
            const file = selectedFiles[0];
            if (!file) return;
            // Preview URL
            const previewUrl = URL.createObjectURL(file);
            // Convert to Base64
            const reader = new FileReader();
            reader.onloadend = () => 
            {
                setFormData({...formData,panphoto:reader.result});                
            };
            reader.readAsDataURL(file);
        }
        if(event.target.id=="photo") 
        {
            const { name, files: selectedFiles } = event.target;
            const file = selectedFiles[0];
            if (!file) return;
            // Preview URL
            const previewUrl = URL.createObjectURL(file);
            // Convert to Base64
            const reader = new FileReader();
            reader.onloadend = () => 
            {
                setFormData({...formData,photo:reader.result});                
            };
            reader.readAsDataURL(file);
        }
    }
    function deleteCustomer(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Subscription/DeleteSubscriber/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadSubscribers();                    
                }
            });
        }
    } 
    function disableCustomer(id)
    {
        if(window.confirm('Would you like to Disable it?\nIt will Disable All Active Plans of this Customer.\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Subscription/DisableSubscriber/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadSubscribers();                    
                }
            });
        }
    }    
    function editCustomer(id)
    {
        apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetSubscriberById/"+id).then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                setFormData({...res.data.data,aadharphoto:"",panphoto:"",photo:""});                
                setShow(true);
            }
        });
    }
    function sortData(colname)
    {
        if(colname=="company" || colname=="sname" || colname=="currentfacility" || colname=="currentplan" || colname=="company")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="planexpiry")
        {
            let arr=[...subscriberdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="planamount")
        {
            let arr=[...subscriberdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);        
    }
    useEffect(()=>{
        loadSubscribers();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">
                    <select className="form-control" id="searchFacility" onChange={searchData} style={{fontSize:'12px'}}>
                        {facilities.map((e, idx) => <option key={`fac-${idx}`} value={e}>{e}</option>)}
                    </select>
                </div>
                <div>
                    <select className="form-control" id="searchPlan" onChange={searchData}  style={{fontSize:'12px'}}>
                        {plans.map((e, idx) => <option key={`plan-${idx}`} value={e}>{e}</option>)}
                    </select>
                </div>
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addSubsriber} /></div>
                <img onClick={()=>{exportArrayToExcel(dataToDisplay,'Customers')}} src={excel} style={{width:'30px',marginLeft:'10px',cursor:'pointer'}} />
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Customer Details</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table id="tblcustomer" className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>View/Edit</th>
                            <th>Delete</th>
                            <th>Disable</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    <td>{e[ee.key]}</td>                            
                                )}
                                <td className="text-center"><img onClick={()=>editCustomer(e.id)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>deleteCustomer(e.id)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>disableCustomer(e.id)} src={disableIcon} alt="" style={{width:'30px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="4"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="5" className="text-center"></th>
                            <th colSpan="4" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="13">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Customers</div>
                                        <div className="row">

                                            <div><input type="text" id="id" onChange={formValueChanged} value={formData.id} className="form-control mt-2 d-none"/></div>
                                            <div><input type="text" id="company" onChange={formValueChanged} value={formData.company} className="form-control mt-2" placeholder="Company Name" /></div>
                                            <div><input type="text" id="name" onChange={formValueChanged} value={formData.name} className="form-control mt-2" placeholder="Contact Person" /></div>                                    
                                            <div className="col-6"><input type="number" id="mobile" onChange={formValueChanged} value={formData.mobile} className="form-control mt-2" placeholder="Mobile No" /></div>
                                            <div className="col-6"><input type="number" id="whatsapp" onChange={formValueChanged} value={formData.whatsapp} className="form-control mt-2" placeholder="Whatsapp No" /></div>                                    
                                            <div><input type="email" id="email" onChange={formValueChanged} value={formData.email} className="form-control mt-2" placeholder="Email" /></div>
                                            <div className="col-6"><input type="text" id="panno" onChange={formValueChanged} value={formData.panno} className="form-control mt-2" placeholder="PAN No" /></div>
                                            <div className="col-6"><input type="number" id="aadhar" onChange={formValueChanged} value={formData.aadhar} className="form-control mt-2" placeholder="AADHAR Id" /></div>
                                            <div><input type="text" id="gstin" onChange={formValueChanged} value={formData.gstin} className="form-control mt-2" placeholder="GSTIN" /></div>
                                            <div><textarea id="address" onChange={formValueChanged} value={formData.address} className="form-control mt-2" placeholder="Address" ></textarea></div>
                                            <div className="col-4"><input type="text" id="state" onChange={formValueChanged} value={formData.state} className="form-control mt-2" placeholder="State" /></div>
                                            <div className="col-4"><input type="text" id="city" onChange={formValueChanged} value={formData.city} className="form-control mt-2" placeholder="City" /></div>
                                            <div className="col-4"><input type="number" id="pincode" onChange={formValueChanged} value={formData.pincode} className="form-control mt-2" placeholder="Pin Code" /></div>
                                            <div className="form-group"><label>AADHAR File:</label><input type="file" accept="image/*" onChange={formValueChanged} id="aadharphoto" className="form-control mt-2" /></div>
                                            <div className="form-group"><label>PAN File:</label><input type="file" accept="image/*" onChange={formValueChanged} id="panphoto"  className="form-control mt-2" /></div>
                                            <div className="form-group"><label>Photo Photo:</label><input type="file" accept="image/*" onChange={formValueChanged} id="photo"  className="form-control mt-2" /></div>
                                        </div>
                                    <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save / Update" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Customers;